import { styled } from '@withjoy/joykit';
import { BOX_SHADOW_8_14_26 } from '@apps/card/constants/boxShadow';

/**
 * The static thumbnail's box, fit inside the frame on both axes like the live preview's scaler
 * does — in CSS alone, so the server render is right before any script runs (PRNT-5494).
 * `--card-ratio` is width / height; `--card-fit` is 0.8 for a square, as the live scaler does.
 * Below container-query support (Safari < 16) the box fits along one axis chosen from the card's
 * orientation (`--card-fallback-width` / `--card-fallback-height`): a landscape card by width,
 * since the frame is always taller than wide, a portrait card by height.
 */
export const FallbackCardBox = styled.div`
  aspect-ratio: var(--card-ratio);
  width: var(--card-fallback-width);
  height: var(--card-fallback-height);
  box-shadow: ${BOX_SHADOW_8_14_26};

  @supports (width: 1cqw) {
    width: calc(min(100cqw, 100cqh * var(--card-ratio)) * var(--card-fit));
    height: calc(min(100cqh, 100cqw / var(--card-ratio)) * var(--card-fit));
  }
`;
